var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5202 7C13.35 7 14.0228 6.32843 14.0228 5.5C14.0228 4.67157 13.35 4 12.5202 4C11.6903 4 11.0176 4.67157 11.0176 5.5C11.0176 6.32843 11.6903 7 12.5202 7Z",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0278 1.9091C17.0278 1.40691 16.6202 1 16.1171 1C16.0603 1 10.6983 1.00073 10.6983 1.00073C10.2138 1.00073 9.75011 0.975272 9.48128 1.24364L1.20189 9.50846C0.932702 9.77683 0.932702 10.2125 1.20189 10.4808L7.53064 16.7987C7.79947 17.0671 8.23586 17.0671 8.50469 16.7987L16.7837 8.53354C17.0525 8.26554 17.027 7.81353 17.027 7.31898C17.027 7.31898 17.0278 1.96583 17.0278 1.9091Z",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrice);
export default __webpack_public_path__ + "static/media/price.c3c91c1224c7497e7ee6173353a6de3f.svg";
export { ForwardRef as ReactComponent };